import { render } from "./BaseFullModal.vue?vue&type=template&id=1a424f79"
import script from "./BaseFullModal.vue?vue&type=script&lang=js"
export * from "./BaseFullModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__